import { Controller, useFormContext, useFieldArray, useWatch } from 'react-hook-form';
import { TextFieldProps } from '@mui/material';

import * as S from './StepInput.styled';

type IProps = {
  inputName: string;
  fieldArrayName: string;
} & TextFieldProps;

export const StepInput = ({ inputName, fieldArrayName, ...rest }: IProps) => {
  const { control, resetField } = useFormContext();
  const { append } = useFieldArray({
    control,
    name: fieldArrayName,
  });

  const items = useWatch({
    control,
    name: fieldArrayName,
  });

  const handleAddValue = (value: string) => {
    if (items.includes(value) || value === '') return;

    append(value);
    resetField(inputName);
  };

  return (
    <Controller
      control={control}
      name={inputName}
      render={({ field }) => (
        <S.TextField
          {...rest}
          {...field}
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === 'Enter') {
              handleAddValue(field.value);
            }
          }}
        />
      )}
    />
  );
};
